import { render, staticRenderFns } from "./departmentlist.vue?vue&type=template&id=1c4c4aea&scoped=true"
import script from "./departmentlist.vue?vue&type=script&lang=js"
export * from "./departmentlist.vue?vue&type=script&lang=js"
import style0 from "./departmentlist.vue?vue&type=style&index=0&id=1c4c4aea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4c4aea",
  null
  
)

export default component.exports